export default __webpack_public_path__ + "static/media/providence.c33f9fda.svg";